import { gql } from '@apollo/client';

export const GET_ALL_SECTION_CONDITIONS = gql`
  query {
    getAllSectionConditions {
      conditionId
      description
      showGroupDescription
      status
    }
  }
`;

export const GET_SECTION_CONDITION = gql`
  query GetSectionCondition($conditionId: Int!) {
    getSectionConditionById(conditionId: $conditionId) {
      conditionId
      description
      showGroupDescription
      status
      sql
      facilityFilter {
        facilityTypes
        facilityStatuses
        treatmentProcesses
        storageTankTypes
        facilityStatusReasons
        systemIndicators {
          indicatorName
          indicatorValues
        }
        facilityIndicators {
          indicatorName
          indicatorValues
        }
      }
      createdUser
      createdTs
      lastUpdatedUser
      lastUpdatedTs
    }
  }
`;

export const SAVE_SECTION_CONDITION = gql`
  mutation SaveSectionCondition($input: UpdateSectionConditionInput!) {
    saveSectionCondition(input: $input) {
      conditionId
      description
      showGroupDescription
      status
    }
  }
`;

export const GET_ACTIVE_SECTION_CONDITIONS = gql`
  query {
    getActiveSectionConditions {
      conditionId
      description
    }
  }
`;
export const GET_ALL_FACILITY_TYPES = gql`
  query {
    getAllFacilityTypes {
      code
      description
    }
  }
`;

export const GET_ALL_FACILITY_STATUSES = gql`
  query {
    getAllFacilityStatuses {
      code
      description
    }
  }
`;

export const GET_ALL_FACILITY_STATUS_REASONS = gql`
  query {
    getAllFacilityStatusReasons {
      code
      description
    }
  }
`;

export const GET_ALL_STORAGE_TANK_TYPES = gql`
  query {
    getAllStorageTankTypes {
      code
      description
    }
  }
`;

export const GET_ALL_TREATMENT_PROCESSES = gql`
  query {
    getAllTreatmentProcesses {
      code
      description
    }
  }
`;

export const GET_ALL_SYSTEM_INDICATOR_TYPES = gql`
  query {
    getAllSystemIndicatorTypes {
      code
      description
      values
    }
  }
`;

export const GET_ALL_FACILITY_INDICATOR_TYPES = gql`
  query {
    getAllFacilityIndicatorTypes {
      code
      description
      values
    }
  }
`;

export const GET_SECTION_CONDITION_FACILITY_COUNT = gql`
  query GetSectionConditionFacilityCount($pwsId: String!, $facilityFilter: FacilityFilterInput!) {
    getSectionConditionFacilityCount(pwsId: $pwsId, facilityFilter: $facilityFilter)
  }
`;
